import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import dayjs from "dayjs";
import CurrencyFilterInput from "@/components/TransactionsPage/TransactionsFilter/FilterForm/CurrencyFilterInput/index";
import fromToCurrenciesInputs from "@/components/TransactionsPage/TransactionsFilter/FilterForm/fromToCurrenciesInputs/index";

export default {
  name: "filter-form",
  components: {
    datePicker: VuePersianDatetimePicker,
    CurrencyFilterInput,
    fromToCurrenciesInputs
  },
  props: [],
  data() {
    return {
      loading: false,
      show: true,
      show2: true,
      select: [],
      selected: false,
      status: [],
      filtersQuery: {
        from_currency: "",
        to_currency: "",
        currency: [],
        created_from: "",
        created_to: "",
        status: []
      },
      statusQuery: {
        type: ""
      },
      createdFrom: "",
      createdTo: "",
      selectedDefaultDate: "",
      isToClosed: false,
      isFromClosed: false,
      dateFilterDialog: false,
      statusFilterDialog: false
    };
  },
  computed: {
    ...mapGetters({
      getStatusList: types.transactions.getters.GET_TRANSACTIONS_STATUS,
      transactionsDrawer: types.transactions.getters.GET_TRANSACTIONS_DRAWER
    }),
    isFiltersQueryEmpty() {
      return (
        !!this.filtersQuery.from_currency ||
        !!this.filtersQuery.to_currency ||
        !!this.createdFrom ||
        !!this.createdTo ||
        this.filtersQuery.currency?.length !== 0 ||
        this.status.length !== 0
      );
    },
    currencyFilterComponent() {
      return this.$route.name === "exchanges"
        ? fromToCurrenciesInputs
        : CurrencyFilterInput;
    },
    currencyFilterProp() {
      return this.$route.name === "exchanges"
        ? {
            fromCurrency: this.filtersQuery.from_currency,
            toCurrency: this.filtersQuery.to_currency
          }
        : this.filtersQuery.currency;
    },
    getQueryParams() {
      Object.entries(this.$route.query).forEach(([key, value]) => {
        if ((key === "status" || key === "currency") && !Array.isArray(value)) {
          this.$route.query[key] = [value];
        }
      });
      return this.$route.query;
    },
    currenciesList() {
      return [...this.getCurrencies];
    },
    statusList() {
      return [...this.getStatusList];
    },
    selectedStatusList() {
      return this.statusList.filter(item => {
        if (this.status.includes(item.value)) {
          return item;
        }
      });
    }
  },
  watch: {
    "$route.query": {
      deep: true,
      handler(updatedQuery) {
        this.filtersQuery = { ...updatedQuery };
        if (!updatedQuery.created_from) {
          this.createdFrom = "";
          this.selectedDefaultDate = "";
        }
        if (!updatedQuery.created_to) {
          this.createdTo = "";
          this.selectedDefaultDate = "";
        }
        if (!updatedQuery.currency) {
          this.filtersQuery.currency = "";
        }
        if (!updatedQuery.status) {
          this.status = [];
        }
      }
    }
  },
  mounted() {
    this.fetchFromQuery();
  },
  methods: {
    ...mapActions({
      transactionsDrawerAction:
        types.transactions.actions.ACTION_TRANSACTIONS_DRAWER
    }),
    openDateFilterDialog() {
      this.dateFilterDialog = true;
    },
    openStatusFilterDialog() {
      this.statusFilterDialog = true;
    },
    selectStatus(item) {
      if (!this.status.includes(item.value)) {
        this.status.push(item.value);
      } else {
        this.status.splice(this.status.indexOf(item.value), 1);
      }
    },
    pushCurrencyQuery(data) {
      this.filtersQuery = { ...this.filtersQuery, ...data };
    },
    setDefaultDateQueries(today, distance) {
      this.createdFrom = this.timestampToDate(distance);
      this.filtersQuery.created_from = distance;
      this.createdTo = this.timestampToDate(today);
      this.filtersQuery.created_to = today;
    },
    setDefaultDate(value) {
      let today = new Date();
      this.selectedDefaultDate = value;
      if (value === "week") {
        let lastWeek = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - 7
        ).getTime();
        this.setDefaultDateQueries(today.getTime(), lastWeek);
      } else if (value === "month") {
        let lastMonth = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          today.getDate()
        ).getTime();
        this.setDefaultDateQueries(today.getTime(), lastMonth);
      } else if (value === "threeMonth") {
        let lastThreeMonth = new Date(
          today.getFullYear(),
          today.getMonth() - 3,
          today.getDate()
        ).getTime();
        this.setDefaultDateQueries(today.getTime(), lastThreeMonth);
      }
    },
    fetchFromQuery() {
      Object.entries(this.getQueryParams).forEach(([key, value]) => {
        if (key === "created_to") {
          this.createdTo = this.timestampToDate(value);
        }
        if (key === "created_from") {
          this.createdFrom = this.timestampToDate(value);
        }
        this.filtersQuery[key] = value;
      });
    },
    onSubmit() {
      this.pushQueryParameters(this.filtersQuery);
      // this.transactionsDrawerAction(!this.transactionsDrawer);
    },
    pushQueryParameters(query) {
      Object.entries(query).forEach(([key, value]) => {
        if (value === undefined || value.length === 0) {
          delete query[key];
        }
      });
      query.status = this.status.length !== 0 ? [...this.status] : undefined;
      if (this.$route.query.category) {
        query = { category: this.$route.query.category, ...query };
      }
      this.$router.replace(
        {
          query: { ...query }
        },
        () => {}
      );
    },
    timestampToDate(timestamp) {
      return dayjs(parseInt(timestamp)).format("YYYY/MM/DD");
    },
    fromDateTimestamp(date) {
      this.selectedDefaultDate = "";
      let UTCString = date._d.toUTCString();
      this.filtersQuery.created_from = dayjs(UTCString).valueOf();
    },
    toDateTimestamp(date) {
      this.selectedDefaultDate = "";
      let UTCString = date._d.toUTCString();
      this.filtersQuery.created_to = dayjs(UTCString).valueOf();
    },
    onOpen() {
      this.isToClosed = true;
    },
    onClose() {
      this.isToClosed = false;
    },
    closeCalendar(data) {
      this.isFromClosed = data;
      this.isToClosed = data;
    },
    activateCalendar(data) {
      this.isFromClosed = data;
      this.isToClosed = data;
    },
    clearCreatedTo() {
      this.filtersQuery.created_to = "";
    },
    clearCreatedFrom() {
      this.filtersQuery.created_from = "";
    }
  }
};
